import React from 'react';

export const dashboardConfig = [
  {
    path: '/dashboards/crm',
    component: React.lazy(() => import('./CRM/index')),
  },
];
